import { Controller } from "@hotwired/stimulus"

// Fills one block of nested address fields ("fields" target) with an address
// that has already been entered somewhere else, so the same address never has
// to be typed twice.
//
// Where that address comes from depends on the form:
//
//   - new client: from the client's own address fields in the same form
//     ("source" target)
//   - admin branch form: from the address of the picked client ("client"
//     target selects an entry of the addresses value)
//   - client branch form: from the signed-in client, the only entry of the
//     addresses value
export default class extends Controller {
  static targets = ["fields", "source", "client"]
  static values = { addresses: Object }

  paste() {
    const address = this.address
    if (!address) return

    Object.entries(address).forEach(([field, value]) => this.fill(field, value))
  }

  get address() {
    if (this.hasSourceTarget) return this.readAddress(this.sourceTarget)
    if (this.hasClientTarget) return this.addressesValue[this.clientTarget.value]

    return Object.values(this.addressesValue)[0]
  }

  readAddress(container) {
    const address = {}

    container.querySelectorAll("[name*='[address_attributes]']").forEach((input) => {
      const field = this.fieldName(input)
      // The record id is part of the fields but identifies the source address.
      if (field && field !== "id") address[field] = input.value
    })

    return address
  }

  fieldName(input) {
    return input.name.match(/\[address_attributes\]\[(\w+)\]$/)?.[1]
  }

  fill(field, value) {
    const input = this.fieldsTarget.querySelector(`[name$="[address_attributes][${field}]"]`)
    if (!input) return

    // Selects enhanced by the combobox controller are rendered by TomSelect and
    // do not pick up a plain value assignment.
    if (input.tomselect) {
      input.tomselect.setValue(value ?? "")
      return
    }

    input.value = value ?? ""
    input.dispatchEvent(new Event("input", { bubbles: true }))
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
